 
import './App.css';
import { BrowserRouter   } from 'react-router-dom';

import CustomMap from './pages/CustomMap'; 
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

 import Layout from './Layout';
 window.$baseUrl = "https://cms.hindujafoundation.org/api";
    window.$name ="https://cms.hindujafoundation.org";

  //    window.$baseUrl = "https://hfdev.hgsinteractive.com/api";
  //  window.$name ="https://hfdev.hgsinteractive.com";

  //   window.$baseUrl = "https://hfcmsuat.hgsinteractive.com/api";
  // window.$name ="https://hfcmsuat.hgsinteractive.com";




function App() {
  return (
 
      <BrowserRouter>
  
          <Layout />
    
      </BrowserRouter>
   
  );
}
export default App;
